var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNote1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 12,
    fill: "url(#pattern0_641_463)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_641_463",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_641_463",
    transform: "matrix(0.0340909 0 0 0.03125 -0.0454545 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_641_463",
    width: 32,
    height: 32,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAahJREFUWIXtl89KAlEUxr/THQUX/SEQJ3B2akRPULaIHkFxFW0jotcRgmgXBC2K3iBIct1CSIkWKTnhJqGFojOnhQiad7wz00yz8Vuec7jfj3Pu3LkXiFg0G9rX9LR5QsQ7DMQCMhkwU9Vs6efAw3AugG5slgGcBmEsQSmbzZezyciSpOowHHOAwTNrywBWwwIgYM0NwL9qAaCpCohx1G7VrwFYsnwyvZ0RNKgAlPIDoOzAoId7J3MA6LRqrwx69mMOuOiAlsBlysjdEpEUgpmyBD4IDQBAiUAlsDxJTgmXinwTRg7gZgRtgKuAfA84iwVAuwD0PwEw8d7ne+PNm/lIyfRWVpDdmFejHIFtx3yPKc4s+d1PS9kBQcNH3cg9+RmBBTsvvXJ4AQCgA1TwZg6ojMeK/CuIHMDNCG4YfOd0FDuJmQWNRleaVye7E06drVZPW+50at9ezMdaz2RW4n3RnYyZzfqUp3IEImEVAQgf/iLeF0VVkbIDQctzB8LWAkAG0JXEAhEDXy4A6CosAALPrC1/nBofxwTKB/o4BSpmc+Pi9+M0cv0APrNwWbDKJnAAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote1);
export default __webpack_public_path__ + "static/media/note1.2840c1275ad910cb1d0d9f2cf70c77bf.svg";
export { ForwardRef as ReactComponent };